import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Newspaper, ChevronDown } from "lucide-react";
import api from "../lib/api";
import { clsx } from "../lib/format";

const ago = (ts) => {
  const s = Math.max(60, Math.floor(Date.now() / 1000 - ts));
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
};

export default function TerminalHeadlines() {
  const [open, setOpen] = useState(() => localStorage.getItem("fx_term_headlines") !== "0");
  const [items, setItems] = useState(null);

  useEffect(() => {
    const load = () => api.get("/news?limit=8").then((r) => setItems(r.data.items)).catch(() => setItems([]));
    load();
    const t = setInterval(load, 300000);
    return () => clearInterval(t);
  }, []);

  const toggle = () => { localStorage.setItem("fx_term_headlines", open ? "0" : "1"); setOpen(!open); };

  return (
    <div className="border-t border-white/5" data-testid="terminal-headlines">
      <button onClick={toggle} data-testid="terminal-headlines-toggle" className="w-full flex items-center justify-between px-4 py-3 hover:bg-white/5 transition-colors">
        <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-fx-s3"><Newspaper className="h-3.5 w-3.5 text-brandblue" /> Headlines</span>
        <ChevronDown className={clsx("h-4 w-4 text-fx-s3 transition-transform", open && "rotate-180")} />
      </button>
      {open && (
        <div className="px-2 pb-3" data-testid="terminal-headlines-list">
          {items === null && Array.from({ length: 4 }).map((_, i) => <div key={i} className="h-12 mx-2 mb-2 rounded bg-white/5 animate-pulse" />)}
          {items?.length === 0 && <div className="text-xs text-fx-s3 px-2 py-3">Headlines unavailable right now.</div>}
          {items?.map((n, i) => (
            <a key={n.id} href={n.link} target="_blank" rel="noopener noreferrer" data-testid={`terminal-headline-${i}`}
              className="block px-2 py-2 rounded hover:bg-white/5 transition-colors group">
              <div className="text-[13px] leading-snug line-clamp-2 group-hover:text-brandblue transition-colors">{n.title}</div>
              <div className="text-[10px] font-mono text-fx-s3 mt-1"><span className="text-brandblue">{n.source}</span> · {ago(n.published_at)}</div>
            </a>
          ))}
          <Link to="/news" data-testid="terminal-headlines-all" className="block text-center text-xs text-brandblue hover:underline mt-1 py-1">View all news</Link>
        </div>
      )}
    </div>
  );
}
